const panoramaOverlay = document.querySelectorAll(".js-panorama-overlay");

if (typeof panoramaOverlay != "undefined" && panoramaOverlay != null) {
    const isHiddenClass = "is-hidden";
    panorama(isHiddenClass);
}

function panorama(isHiddenClass) {
    panoramaOverlay.forEach((overlay) => {
        overlay.addEventListener("click", (e) => {
            e.preventDefault();
            overlay.classList.add(isHiddenClass);
        });
    });
}